import type { SVGProps } from 'react';

type IconApertureProps = SVGProps<SVGSVGElement> & {
    /** Blades wide open (f/1,4) or closed down (f/22). */
    open?: boolean;
};

/**
 * The brand's aperture mark. The outer ring is fixed; only the blades inside
 * the clip scale between open and closed — no rotation, no fade, as drawn.
 */
export function IconAperture({ open = true, ...props }: IconApertureProps) {
    const blades = {
        transform: open ? 'scale(1)' : 'scale(0.25)',
        transformBox: 'fill-box',
        transformOrigin: 'center center',
        transition: 'transform 360ms ease-in-out',
    } as const;

    return (
        <svg
            viewBox="0 0 26 26"
            fill="none"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={1.5}
            {...props}
        >
            <defs>
                <clipPath id="icon-aperture-clip">
                    <circle cx="98.268" cy="96.298" r="34.766" />
                </clipPath>
            </defs>
            <g transform="matrix(0.13,0,0,0.13,0,0)">
                <g transform="matrix(2.6551,0,0,2.6551,-160.912,-155.682)">
                    <g clipPath="url(#icon-aperture-clip)">
                        <g style={blades}>
                            <g transform="matrix(1.15341,0,0,1.15341,398.765,-544.658)">
                                <g transform="matrix(1.7578,0,0,1.7578,148.882,226.844)">
                                    <path
                                        d="M-232.912,174.625L-221.924,180.969L-221.924,193.656L-232.912,200L-243.899,193.656L-243.899,180.969L-232.912,174.625Z"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="0.67"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                                <g transform="matrix(0.866025,-0.5,0.5,0.866025,-238.964,-56.5091)">
                                    <path
                                        d="M-336.139,500.451L-157.728,500.451"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.17"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                                <g transform="matrix(-4.996e-16,-1,1,-4.996e-16,-780.295,230.313)">
                                    <path
                                        d="M-336.139,500.451L-157.728,500.451"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.17"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                                <g transform="matrix(-0.866025,-0.5,0.5,-0.866025,-801.86,843.736)">
                                    <path
                                        d="M-336.139,500.451L-157.728,500.451"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.17"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                                <g transform="matrix(-0.866025,0.5,-0.5,-0.866025,-282.095,1168.69)">
                                    <path
                                        d="M-336.139,500.451L-157.728,500.451"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.17"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                                <g transform="matrix(-2.22045e-16,1,-1,-2.22045e-16,259.235,881.102)">
                                    <path
                                        d="M-336.139,500.451L-157.728,500.451"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.17"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                                <g transform="matrix(0.866025,0.5,-0.5,0.866025,280.801,268.466)">
                                    <path
                                        d="M-336.139,500.451L-157.728,500.451"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.17"
                                        vectorEffect="non-scaling-stroke"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <circle cx="98.268" cy="96.298" r="34.766" fill="none" stroke="currentColor" strokeWidth="3.38" />
                </g>
            </g>
        </svg>
    );
}
